import { Component, OnInit } from '@angular/core';
import { PartnerService } from '../../../services/partner.service';

@Component({
  selector: 'app-partners-list',
  templateUrl: './partners-list.component.html',
  styleUrls: ['./partners-list.component.scss']
})
export class PartnersListComponent implements OnInit {

  // showPartnersMgmt = true;
  // showPartnerGroupsMgmt = false;

  constructor(private partnerService: PartnerService) { }

  ngOnInit() {
    // this.partnerService.showPartnersMgmt$.subscribe((x) => {
    //   this.showPartnersMgmt = x;
    // });

    // this.partnerService.showPartnerGroupsMgmt$.subscribe((x) => {
    //   this.showPartnerGroupsMgmt = x;
    // });

  }
}
